import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasToastProvider, GasConfirmProvider } from '../../shared/kit';
import App from './App';
import type { ShopProductInitData } from './types';
import './style.css';

/**
 * Monte toutes les buy-box shop-product présentes dans le document.
 * - Single / shortcode : #gas-shop-product-app
 * - Bloc shop_product (multi-instance) : [data-gas-shop-product-island]
 */
function mountShopProductIslands(): void {
    const mounts = document.querySelectorAll<HTMLElement>('[data-gas-shop-product-island], #gas-shop-product-app');
    mounts.forEach((mountEl) => {
        if (!mountEl.isConnected || !mountEl.dataset.reactInit) {
            return;
        }
        if (mountEl.dataset.gasMounted === '1') {
            return;
        }

        let initData: ShopProductInitData;
        try {
            initData = JSON.parse(mountEl.dataset.reactInit) as ShopProductInitData;
        } catch (error) {
            window.console?.error?.('[gas-shop-product] init JSON invalide', error);
            return;
        }

        mountEl.dataset.gasMounted = '1';
        createRoot(mountEl).render(
            <React.StrictMode>
                <GasToastProvider>
                    <GasConfirmProvider>
                        <App initData={initData} mountEl={mountEl} />
                    </GasConfirmProvider>
                </GasToastProvider>
            </React.StrictMode>,
        );
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountShopProductIslands);
} else {
    mountShopProductIslands();
}
